import { render, staticRenderFns } from "./ExchangeMails.vue?vue&type=template&id=0eb850b9"
import script from "./ExchangeMails.vue?vue&type=script&lang=js"
export * from "./ExchangeMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb850b9')) {
      api.createRecord('0eb850b9', component.options)
    } else {
      api.reload('0eb850b9', component.options)
    }
    module.hot.accept("./ExchangeMails.vue?vue&type=template&id=0eb850b9", function () {
      api.rerender('0eb850b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExchangeMails.vue"
export default component.exports